import { useHistory } from 'react-router-dom'
import { AxiosError } from 'axios'

import { AppRoute } from 'routing/AppRoute.enum'
import { Queries } from 'api/queries.enum'
import {
    GetPulseSurveyResultsParams,
    GetPulseSurveyResultsResponse,
} from 'api/actions/pulseSurveys/pulseSurveysActions.types'
import { getPulseSurveyResults } from 'api/actions/pulseSurveys/pulseSurveysActions'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { preventRefetchQueryOptions } from 'utils/queryOptions'
import { useQuery } from 'hooks/useQuery'

export const useGetPulseSurveyResults = (params: GetPulseSurveyResultsParams, options?: { enabled?: boolean }) => {
    const history = useHistory()

    return useQuery<GetPulseSurveyResultsResponse, AxiosError>({
        queryKey: [Queries.getPulseSurveyResults, params],
        queryFn: () => getPulseSurveyResults(params),
        onError: () => {
            history.push(generateCompanyURI(AppRoute.PulseSurvey))
        },
        enabled: options?.enabled,
        ...preventRefetchQueryOptions,
    })
}
